import * as React from "react"
import { Box } from "@mui/material"

export default function TourTarget({ name, height = 120 }) {
    return (
        <Box
            data-tour={name}
            sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height,
                pointerEvents: "none",
            }}
        />
    )
}
